import React from 'react';
import Style from './style.sass';
import Button from './button';

const Input = ({ label, onSubmit, onChange, value, placeholder}) => {
  return (
    <form className={Style.Postal__form} onSubmit={onSubmit}>
      <label>{ label }</label>
      <input  className={Style.Postal__input} type='text' name='name' onChange={onChange} value={value} placeholder={placeholder}/>
      <Button type='submit' text='検索'/>
    </form>
  );
}

export default Input;